module.exports = __webpack_public_path__ + "img/27002d8.jpg";